<template>

  <div class="inputGroup outerDiv" >
    <input :id="'Item' + item.id" name="option1" type="checkbox" 
      v-model="item.isChecked" 
      @change="testfunc(item)" />
    <label :for="'Item' + item.id">{{item.vdisplay}}</label>
  </div>
 
</template>


<script>
export default {
    props: [ 'item' , 'itemlimit', 'selectedItems'],
    data(){
        return {
            isChecked: false
        }
    },
    computed: {
      tooMany: function(){
        return this.itemlimit <= this.selectedItems.length;
      }
    },
    methods: {
      testfunc: function(t){

        let idx = this.selectedItems.indexOf(t.id);
        if (idx > -1 ){
          this.selectedItems = this.selectedItems.splice(idx,1);
          t.isChecked = false;
        } else {
          if (!this.tooMany) {
            t.isChecked = true;
            this.selectedItems.push(t.id)
          } else {
            t.isChecked = false;
          }
        }
      }
    }

}

//@change="$emit('selectItem', this)" />
</script>

<style lang="scss" scoped >
.inputGroup {
    //background-color: #fff;
    display: block;
    margin: 10px 0;
    position: relative;
    border-radius: 10px;

    label {
      padding: 12px 25px;
      width: 100%;
      display: block;
      text-align: left;
      color: #3C454C;
      cursor: pointer;
      position: relative;
      z-index: 2;
      transition: color 200ms ease-in;
      overflow: hidden;

      &:before {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        content: '';
        background-color: #dae0e5;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%) scale3d(1, 1, 1);
        transition: all 300ms cubic-bezier(0.4, 0.0, 0.2, 1);
        opacity: 0;
        z-index: -1;
      }

    
      &:after {
        background-position: 2px 3px;
        
        z-index: 2;
        position: absolute;
        right: 30px;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
        transition: all 200ms ease-in;
      }
    }

    input:checked ~ label {
      //color: #fff;

      &:before {
        transform: translate(-50%, -50%) scale3d(56, 56, 1);
        opacity: 1;
      }

    }

    input {
      width: 32px;
      height: 32px;
      order: 1;
      z-index: 2;
      position: absolute;

      transform: translateY(-50%);
      cursor: pointer;
      visibility: hidden;
    }
  }


// codepen formatting
.outerDiv {
  padding: 0 16px;
  max-width: 550px;
  margin: 10px auto;
  font-size: 18px;
  font-weight: 600;
  line-height: 36px;
}



*,
*::before,
*::after {
  box-sizing: inherit;
}




</style>

